import { Context, createContext, FC, PropsWithChildren, useMemo } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export type TFormValueTransformer = (value: string, ...others: any[]) => string

const stringIdentity: TFormValueTransformer = (value: string) => value

export const SFormProviderContext: Context<{
  transformer: TFormValueTransformer
}> = createContext({
  transformer: stringIdentity,
})

type SFormProviderProps = {
  transformer?: TFormValueTransformer
}
export const SFormProvider: FC<PropsWithChildren<SFormProviderProps>> = ({ transformer, children }) => {
  const value = useMemo(
    () => ({
      transformer: transformer || stringIdentity,
    }),
    [transformer]
  )

  return <SFormProviderContext.Provider value={value}>{children}</SFormProviderContext.Provider>
}
